import { useQuery } from "@tanstack/react-query";
import { partnerApiService } from "@/services/partner-api.service";

export const useBillingInvoices = () => {
	return useQuery({
		queryKey: ["partner", "billing", "invoices"],
		queryFn: partnerApiService.listInvoices,
	});
};
